// eslint-disable-next-line import/no-cycle
import Ajax from '@/assets/js/request'
import c from '@/assets/js/config'
import { Message, Loading } from 'element-ui'

let loadingInstance

const beforeEach = async (router, to, from, next) => {
  loadingInstance = Loading.service({ fullscreen: true })

  // 继承或直接记录目的地
  const nextConfig = {
    path: '/login',
    query: { backurl: to.fullPath },
  }

  if (to.path.includes('/inner') && !localStorage.getItem(`${c.Storage}token`)) {
    // 不存在token，进入登陆页，中断后继续
    Message.error({
      message: '请重新登陆',
      duration: 2000,
    })
    next(nextConfig)
  } else if (to.path.includes('/inner')) {
    // 校验token，进入登陆页，中断后继续
    await Ajax('/inner/auth/check')
      .then(() => next())
      .catch(err => {
        Message.error({
          message: `编号：2001，${err.message}`,
          duration: 2000,
        })
        localStorage.removeItem(`${c.Storage}token`)
        next(nextConfig)
      })
  } else if (to.path.includes('/login') && localStorage.getItem(`${c.Storage}token`)) {
    // 登陆页面校验token，进入主页
    await Ajax('/inner/auth/check')
      .then(() => {
        if (to.query.backurl) {
          next(to.query.backurl)
        } else if (from.path.includes('/inner')) {
          next(from.fullPath)
          router.app.$nextTick(() => loadingInstance.close())
        } else {
          next('/inner')
        }
      })
      .catch(() => {
        localStorage.removeItem(`${c.Storage}token`)
        next()
      })
  } else {
    // 非处理outer和无状态登陆页
    next()
  }
}

const beforeEachCheck = async (router, to, from, next) => {
  const selectId = localStorage.getItem(`${c.Storage}token`)
  if (to.name === 'login') {
    next()
  } else if (
    to.path.includes('/inner')
    && !to.name.includes('users')
    && from.name
    && from.name.includes('users')
    && !selectId
  ) {
    Message.error({
      message: '请选择查看的用户',
      duration: 2000,
    })
    next(false)
    router.app.$nextTick(() => loadingInstance.close())
  } else if (
    (!from.name || !from.name.includes('users'))
    && !to.name.includes('users')
    && !selectId
  ) {
    Message.error({
      message: '请选择查看的用户',
      duration: 2000,
    })
    next('/inner/users')
  } else {
    next()
  }
}

const afterEach = async router => {
  router.app.$nextTick(() => loadingInstance.close())
}

export default {
  beforeEach,
  beforeEachCheck,
  afterEach,
}



// WEBPACK FOOTER //
// ./src/router/each.js